import {
  Button as MuiButton,
  CircularProgress,
  ButtonProps,
} from "@mui/material";

interface Props extends ButtonProps {
  loading?: boolean;
  loadingText?: string;
}

const Button = (props: Props) => {
  const { loading = false, loadingText, ...rest } = props;
  return (
    <MuiButton
      {...rest}
      disabled={props.disabled || loading}
      endIcon={
        loading ? (
          <CircularProgress size="0.8rem" color="inherit" />
        ) : (
          props.endIcon
        )
      }
    >
      {loading ? loadingText || props.children : props.children}
    </MuiButton>
  );
};

export default Button;
